import React, { useState, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import Navbar from '@/components/landing/Navbar';
import HeroSection from '@/components/landing/HeroSection';
import ExperienceBanner from '@/components/landing/ExperienceBanner';
import ServicesSection from '@/components/landing/ServicesSection';
import BookingSection from '@/components/landing/BookingSection';
import GallerySection from '@/components/landing/GallerySection';
import GiftCardSection from '@/components/landing/GiftCardSection';
import LocationSection from '@/components/landing/LocationSection';
import Footer from '@/components/landing/Footer';
import BookingModal from '@/components/landing/BookingModal';

const Landing = () => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const { scrollYProgress } = useScroll();
  
  // Set page title
  useEffect(() => {
    document.title = 'MAUMA Beauty House - Head Spa en Carrasco';
  }, []);
  
  // Smooth scroll behavior
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="relative bg-[#0a0a0a] overflow-hidden">
      {/* Navbar */}
      <Navbar onBookingClick={() => setIsBookingModalOpen(true)} />
      
      {/* Progress bar */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#C9A86A] via-[#6B7F5C] to-[#C9A86A] origin-left z-50"
        style={{ scaleX: scrollYProgress }}
      />

      <div id="hero">
        <HeroSection onBookingClick={() => setIsBookingModalOpen(true)} />
      </div>
      <ExperienceBanner />
      <div id="servicios">
        <ServicesSection onBookingClick={() => setIsBookingModalOpen(true)} />
      </div>
      <div id="galeria">
        <GallerySection />
      </div>
      <BookingSection onBookingClick={() => setIsBookingModalOpen(true)} />
      <div id="giftcards">
        <GiftCardSection />
      </div>
      <div id="ubicacion">
        <LocationSection />
      </div>
      <Footer />

      <BookingModal
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
      />
    </div>
  );
};

export default Landing;
